import React, { useState } from "react";
import styles from "./SortAlgorithm.module.css";
import { ProductEntry } from "../../../types/Product";

// Define the type for sort options
export type SortOption = 'default' | 'priceLowToHigh' | 'priceHighToLow' | 'scoreLowToHigh' | 'scoreHighToLow';

// Sorting function
const sortProducts = (option: SortOption, products: ProductEntry[], setProducts: React.Dispatch<React.SetStateAction<ProductEntry[]>>, setSortOption: React.Dispatch<React.SetStateAction<SortOption>>) => {
  // console.log("Products", products);
  let sortedProducts = [...products];
  switch (option) {
    case 'priceLowToHigh':
      sortedProducts.sort((a, b) => a[0].price - b[0].price);
      break;
    case 'priceHighToLow':
      sortedProducts.sort((a, b) => b[0].price - a[0].price);
      break;
    case 'scoreLowToHigh':
      sortedProducts.sort((a, b) => a[0].score - b[0].score);
      break;
    case 'scoreHighToLow':
      sortedProducts.sort((a, b) => b[0].score - a[0].score);
      break;
    default:
      break;
  }
  setProducts(sortedProducts);
  setSortOption(option);
};
interface SortProps {
  sortOption: SortOption;
  handleSort: (option: SortOption) => void;
}
const Sort: React.FC<SortProps> = ({
  sortOption,
  handleSort
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const sortOptionText: Record<SortOption, string> = {
    default: "Default",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    scoreLowToHigh: "Score: Low to High",
    scoreHighToLow: "Score: High to Low"
  };
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const handleOptionClick = (option: SortOption) => {
    handleSort(option);
    setDropdownOpen(false);
  };
  return <div className={styles.sortOptionText} data-sentry-component="Sort" data-sentry-source-file="SortAlgorithm.tsx">
            <label htmlFor='sortOption'>Sort by:</label>
            <button onClick={toggleDropdown} className={styles.dropdownButton}>
              {sortOptionText[sortOption]}
            </button>
            {isDropdownOpen && <ul className={styles.dropdownMenu}>
                    {Object.entries(sortOptionText).map(([value, text]) => <li key={value} onClick={() => handleOptionClick(value as SortOption)}>{text}</li>)}
                </ul>}
        </div>;
};
export { sortProducts, Sort };